import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { Team } from "@/modules/team/entity";
import { BankLog } from "@/modules/finances/entity";
import { Season } from "@/modules/season/entity";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import NavBarMenu from "@/modules/vue/components/NavBarMenu.vue";
import NavBarMenuItem from "@/modules/vue/components/NavBarMenuItem.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'FinanceLayout',
  async setup(__props) {
    let __temp, __restore;
    const activeNames = ref([]);
    const route = useRoute();
    const season = ([__temp, __restore] = _withAsyncContext(() => Season.current()), __temp = await __temp, __restore(), __temp);
    const team = ref(([__temp, __restore] = _withAsyncContext(() => Team.current()), __temp = await __temp, __restore(), __temp));
    const logs = ref(([__temp, __restore] = _withAsyncContext(() => BankLog.createQueryBuilder('log').leftJoin('log.season', 'season').andWhere('season.id = :seasonId', {
      seasonId: season.id
    }).orderBy('log.id').getMany()), __temp = await __temp, __restore(), __temp));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_renderSlot(_ctx.$slots, "title")]),
        submenu: _withCtx(() => [_createVNode(NavBarMenu, null, {
          default: _withCtx(() => [_createVNode(NavBarMenuItem, {
            to: {
              name: 'bank.index',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.MoneyBillAltRegular,
            label: _ctx.$t('yearly')
          }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
            to: {
              name: 'bank.monthly',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.MoneyBillAltRegular,
            label: _ctx.$t('monthly')
          }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
            to: {
              name: 'sponsors.index',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.DeviceTv,
            label: _ctx.$t('sponsoring')
          }, null, 8, ["to", "icon", "label"])]),
          _: 1
        })]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      });
    };
  }
});